<template>
  <div class="placeOrder warp">
    <a-spin :spinning="spinning">
      <div style="font-size: 18px;font-weight: 600;color: #333333;margin-bottom:20px;">请确认订单信息</div>
      <div v-if="shopsData">
        <div style="display: flex;background: #cccccc4f;padding: 10px;">
          <span
            :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '40' : '30'}%;padding-left:20px;`">商品信息</span>
          <span
            :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '10' : '30'}%;text-align:center;`">{{ shopsData.shopsData.productDetailData.timeSkuStatus ? `单价(元/${shopsData.shopsData.productDetailData.timeSkuName})` : '单价(元)' }}</span>
          <span
            :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '10' : '30'}%;text-align:center;`">数量</span>
          <span v-if="shopsData.shopsData.productDetailData.timeSkuStatus"
            style="width:20%;text-align:center;">租赁时间(单位/{{ shopsData.shopsData.productDetailData.timeSkuName }})</span>
          <span
            :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '20' : '30'}%;text-align:center;`">金额(元)</span>
        </div>
        <div v-for="(item, index) in shopsData.shopsData.shortShopCar.products" :key="index"
          style="display:flex;align-items:center;padding:20px 10px;border: 1px solid #E5E5E5FF;border-top: none;">
          <span
            :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '40' : '30'}%;display:flex;align-items:stretch;`">
            <div style="width: 100px;height: 100px;overflow: hidden;">
              <img :src="item.image || shopsData.shopsData.productDetailData.images[0]" height="100%" alt="" srcset="">
            </div>
            <div
              style="display: flex;flex-direction: column;justify-content: space-between;box-sizing: border-box;padding: 10px 10px;width: calc(100% - 100px);">
              <div style="font-size:14px;font-weight:bold;">{{ shopsData.shopsData.productDetailData.productName }}</div>
              <div style="font-size: 13px;color: #767676;">
                <div>{{ item.skuName }}</div>
                <div v-if="item.extraSkuName">{{ item.extraSkuName }}</div>
              </div>
            </div>
          </span>
          <span :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '10' : '30'}%;text-align:center;`">
            {{ item.price }}
          </span>
          <span :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '10' : '30'}%;text-align:center;`">
            x{{ item.buyNum }}
          </span>
          <span v-if="shopsData.shopsData.productDetailData.timeSkuStatus" style="width:20%;text-align:center;">
            <div>起始日期:{{ item.timeArea[0] }}</div>
            <div>结束日期:{{ item.timeArea[1] }}</div>
          </span>
          <span :style="`width:${shopsData.shopsData.productDetailData.timeSkuStatus ? '20' : '30'}%;text-align:center;`">
            {{ item.totalPrice }}
          </span>
        </div>
        <div v-if="shopsData.shopsData.shortShopCar.products.length == 0"
          style="display: flex;align-items: center;justify-content: center;height: 200px;margin-bottom: -10px;font-size: 20px;color: #939393;">
          您暂未选择商品哦
        </div>
        <div style="background: #F7F7F7FF;padding: 10px 20px;margin: 20px 0;">
          <el-input type="textarea" :rows="6" placeholder="如有其它需求,请备注~" maxlength="300" show-word-limit
            v-model="textarea">
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="display: flex;align-items: center;background: #F1F2F7FF;padding: 10px 20px;">
            <div style="width:60%;text-align:left;">
              <span>已选规格 <b
                  style="font-size:18px;margin:0 4px;">{{ shopsData.shopsData.shortShopCar.products.length }}</b> 种</span>
              <span style="margin-left:20px;">总计数量 <b
                  style="font-size:18px;margin:0 4px;">{{ getCurTotalNum() }}</b></span>
            </div>
            <div style="margin-left:auto;display: flex;align-items: center;">
              <div style="display: flex;align-items:baseline;">
                <span>需付款:</span>
                <span style="color:#FF4747FF;margin-left:4px;">¥</span>
                <span style="font-size:20px;color:#FF4747FF;margin:0 15px 0 2px;">{{ getCurTotalPrice() }}</span>
              </div>
              <div @click="groupBuyNow()"
                style="cursor: pointer;background-color:#F77B0BFF;font-size:15px;color:#ffffff;height: 50px;margin: -10px -20px -10px 0;padding: 0 20px;display: flex;align-items: center;justify-content: center;">
                提交订单
              </div>
            </div>
          </div>
        </span>
      </div>
    </a-spin>
  </div>
</template>

<script>
import api from "@/api_serv";
import { mapGetters, mapMutations } from "vuex";
import { listSearchMixin } from "../../config/mixin";
export default {
  name: "placeOrder",
  mixins: [listSearchMixin],
  components: {
  },
  data() {
    return {
      spinning: false,
      textarea: '',
      payInfo: {}
    };
  },
  created() {
  },
  mounted() {
    console.log(this.shopsData.shopsData)
    this.lookShopCat()
  },
  computed: {
    ...mapGetters([
      "newAddress", // 新增修改收货地址
      "shopsData",
      "userInfo"
    ]),
  },
  methods: {
    ...mapMutations({
      seNewAddress: "SET_NEWADDRESS", // 新增修改收货地址
      setAreacode: "SET_AREACODE", // 新增修改收货地址
      setCartNumber: "SET_CARTNUMBER", // 采购单数量
      setShoppingCart: "SET_SHOPPINGCART", // 采购单
    }),
    // 查看采购单
    lookShopCat() {
      console.log(this.shopsData.shopsData.shortShopCar)
      let shopArray = []
      
      for (let i = 0; i < this.shopsData.shopsData.shortShopCar.products.length; i++) {
        let exSkus = []
        for (let j = 0; j < this.shopsData.shopsData.shortShopCar.products[i].extraSku.extraSkuArray.length; j++) {
          let sku = {
            skuId: this.shopsData.shopsData.shortShopCar.products[i].extraSku.extraSkuArray[j].skuId
          }
          exSkus.push(sku)
        }
        let timeSkuEnd = ''
        let timeSkuStart = ''
        if (this.shopsData.shopsData.shortShopCar.products[i].timeArea && this.shopsData.shopsData.shortShopCar.products[i].timeArea.length > 0) {
          timeSkuEnd = this.shopsData.shopsData.shortShopCar.products[i].timeArea[1]
          timeSkuStart = this.shopsData.shopsData.shortShopCar.products[i].timeArea[0]
        }
        let skusItem = [
          {
            exSkus: exSkus,
            number: this.shopsData.shopsData.shortShopCar.products[i].buyNum,
            skuId: this.shopsData.shopsData.shortShopCar.products[i].skuId,
            timeSkuEnd: timeSkuEnd,
            timeSkuStart: timeSkuStart
          }
        ]
        let shopItem = {
          category: this.shopsData.shopsData.productDetailData.category,
          shopId: this.shopsData.shopsData.productDetailData.shopId,
          skus: skusItem
        }
        shopArray.push(shopItem)
      }
      console.log(shopArray)
      let data2 = {
        shops: shopArray
      }
      let params2 = {
        url: api.getSettlement,
        method: "POST",
        data: data2,
      };
      this.sendReq(params2, (res2) => {
        console.log(res2.data)
      })
    },
    groupBuyNow() {//提交订单
      let self = this;
      // let skus = {}
      // for (let i = 0; i < this.shopsData.shopsData.shortShopCar.products.length; i++){

      // }
      let skus = this.shopsData.shopsData.shortShopCar.products.map(el => {
        let extraSku = {}
        if (el.extraSku&&el.extraSku.extraSkuArray) {
          extraSku = el.extraSku.extraSkuArray.map(ets => {
            return {
              skuId: ets.skuId
            }
          })
        }

        return {
          number: el.buyNum,
          skuId: el.skuId,
          exSkus: el.extraSku ? [...extraSku] : [],
          timeSkuStart: el.timeArea[0],
          timeSkuEnd: el.timeArea[1],
        }

      })
      let subData = {
        category: '1',
        remark: this.textarea,
        shops: [
          {
            shopId: this.shopsData.shopsData.collectData.shopId,
            skus: skus
          }
        ]
      }
      console.log(subData)
      let params = {
        url: api.orderSubmit,
        method: "POST",
        data: subData,
      };
      self.spinning = true;
      self.sendReq(params, (res) => {
        self.spinning = false;
        if (res.code === "200") {
          // self.pay(res.data)
          self.payInfo = res.data;
          // self.getTrolleyList();
          // console.log(res.data, '提交返回')

          // if (self.payType == 1) {
          //   self.weChatPay(res);
          // } else if (self.payType == 3) {
          //   self.offlinePay(res);
          // } else if (self.payType == 4) {
          this.$message.success("订单提交成功，将为您跳转订单详情...");
          setTimeout(() => {
            this.$router.push({
              path: "/orderDetail_B2B_serv",
              query: {
                parentId: res.data.orderId,
              },
            });
          }, 2000);
          // } else if (self.payType == 6) {
          //   if (res.data && res.data.url) {
          //     self.$message({
          //       message: '订单提交成功，即将跳转支付...',
          //       type: "success",
          //     });
          //     setTimeout(() => {
          //       var a = document.createElement('a');
          //       a.setAttribute('href', res.data.url);
          //       a.setAttribute('target', '_blank');
          //       a.setAttribute('id', "toPay");
          //       // 防止反复添加
          //       if (!document.getElementById("toPay")) document.body.appendChild(a);
          //       a.click();
          //       // window.location.href = res.data.url
          //       // window.open(res.data.url)
          //     }, 2000);
          //   }
          // }
          // self.weChatDialog = true
          // self.chatTimer = setInterval(() => {
          //   self.checkPay(res.data)
          // }, 3000)
        } else if (res.code === "70007") {
          self.$message({
            message:
              "订单金额超额（≥5万元），暂不支持在线支付，您可选择转账汇款或账期支付进行支付。",
            type: "warning",
          });
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    getCurTotalPrice() {
      let finalPrice = 0;
      if (this.shopsData.shopsData.shortShopCar.products.length == 0) {
        finalPrice = 0
      } else {
        let num = 0;
        this.shopsData.shopsData.shortShopCar.products.map(el => {
          num += Number(el.totalPrice)
        })
        finalPrice = num;
      }
      return finalPrice.toFixed(2)
    },
    getCurTotalNum() {
      if (this.shopsData.shopsData.shortShopCar.products.length == 0) {
        return 0
      } else {
        let num = 0;
        this.shopsData.shopsData.shortShopCar.products.map(el => {
          num += el.buyNum
        })
        return num;
      }

    },
  },
  watch: {
  },
};
</script>
<style lang="scss">
.main {
  background: #f5f5f5;
}
</style>
<style lang="scss" scoped>
.placeOrder {
  margin: 20px auto;
  padding: 27px 48px;
  background: #ffffff;

  .poTitle {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
  }

  .poAddressList {
    display: flex;
    width: 100%;
    border: 1px solid #e5e5e5;
    padding: 20px;
    margin-bottom: 30px;
    box-sizing: border-box;
    justify-content: space-between;

    .poAddListTit {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 177px;
      height: 177px;
      border: 2px dotted #c9c9c9;
      border-radius: 8px;
      margin: 22px;

      i {
        color: #c9c9c9;
        font-size: 46px;
        margin-bottom: 10px;
      }

      span:nth-child(2) {
        color: #76787a;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .poAddListBox {
      width: 70%;
      display: flex;
      justify-content: flex-end;

      &>div:first-child {
        font-size: 16px;
        color: #333333;
        padding: 19px 27px 0 0;
      }

      &>div:last-child {}

      // margin:20px 50px 0 50px;
      .showMoreBox {
        width: 843px;
        height: 203px;
        overflow: hidden;
      }

      .showMoreAdd {
        height: auto;
      }

      .addressItem {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        width: 100%;
        border: 1px solid #e5e5e5;
        margin-bottom: 7px;
        height: 62px;
        cursor: pointer;
        padding-right: 27px;

        span {
          color: #666666;
          font-size: 14px;
        }

        span:nth-child(1) {
          width: 180px;
          height: 31px;
          line-height: 31px;
          // text-align: center;
          // border: 1px solid #CCCCCC;
          // border-radius: 2px;
          padding: 0 0 0 27px;
          margin-right: 15px;
          position: relative;
          // i {
          //   font-size: 16px;
          //   height: 16px;
          //   line-height: 16px;
          //   position: absolute;
          //   right: -1px;
          //   bottom: 0;
          //   color: $mainColor;
          // }
        }

        span:nth-child(2) {
          width: 280px;
          margin-right: 20px;
        }

        .phone {
          margin-right: 20px;
        }

        .defaultAddress {
          width: 100px;
          display: flex;
          align-items: center;
          margin-left: auto;
        }

        .hasHeader:before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 5px;
          background: #f77b0b;
          border-radius: 50%;
          margin-right: 7px;
          margin-left: -7px;
        }

        .el-icon-edit {
          font-size: 18px;
          padding-right: 15px;
        }
      }

      .openMore {
        font-size: 20px;
        color: #cccccc;
        cursor: pointer;
        text-align: center;
      }

      .currentAddress {
        span:nth-child(1) {
          border-color: $mainColor;
        }
      }

      .addressActive {
        position: relative;
        border: 1px solid #f77b0b;

        &>i {
          position: absolute;
          right: -1px !important;
          bottom: -1px;
          color: #f77b0b;
          font-size: 16px;
          height: 16px;
          line-height: 16px;
        }
      }

      .showMoreAdd {
        height: auto;
      }
    }
  }

  >>>.el-dialog {
    .el-dialog__body {
      background: #f8f8f8;
    }

    .el-dialog__header {
      text-align: center;
    }

    .el-dialog__footer {
      text-align: center;

      .dialog-footer {
        text-align: center;

        button {
          height: 45px;
          width: 160px;
        }
      }
    }
  }

  .poAddressBox {
    .noAddress {
      width: 300px;
      height: 166px;
      display: flex;
      align-items: center;
      text-align: center;
      border: 2px solid #dddddd;
      border-radius: 4px;
      margin-top: 40px;
      justify-content: center;
      cursor: pointer;
      margin-bottom: 70px;

      span {
        font-size: 16px;
        color: #666666;
        display: block;
      }

      span:nth-child(1) {
        font-size: 26px;
        margin-bottom: 18px;
      }
    }
  }

  .orderList {
    background: #fcfcfc;
    border: 1px solid #e5e5e5;
    margin-bottom: -1px;

    .orderInfoTit {
      width: 100%;
      display: flex;
      height: 44px;
      line-height: 44px;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
    }

    span {
      text-align: center;
    }

    span:nth-child(1) {
      width: 40%;
      text-align: left;
      padding-left: 125px;
      box-sizing: border-box;
    }

    span:nth-child(2) {
      width: 20%;
      text-align: left;
    }

    span:nth-child(3) {
      width: 15%;
    }

    span:nth-child(4) {
      width: 15%;
    }

    span:nth-child(5) {
      width: 10%;
    }

    span:nth-child(6) {
      width: 10%;
    }
  }

  .couponBox {
    .couponTitle {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #e5e5e5;

      span {
        color: #333333;
        cursor: pointer;

        i {
          margin-left: 5px;
        }
      }
    }

    .discountList {
      margin-top: 30px;

      .couponItem {
        width: 245px;
        border: 1px solid #eeeeee;
        border-radius: 18px;
        overflow: hidden;
        margin: 0 50px 50px 0;
        float: left;
        cursor: pointer;

        // &:nth-child(4n) {
        //   margin-right: 0;
        // }
        .couponItemTop {
          background: #fd5b5b;
          color: #ffffff;
          padding: 20px;
          box-sizing: border-box;
          position: relative;

          img {
            opacity: 0.2;
            position: absolute;
            top: 40%;
          }

          .couponType {
            position: absolute;
            top: 1px;
            right: -33px;
            width: 100px;
            transform: rotate(45deg);
            background: #ffffff;
            color: #fd5b5b;
            text-align: center;
            height: 40px;
            line-height: 50px;
          }

          span {
            font-size: 12px;
            display: block;
            margin-bottom: 18px;

            i {
              margin-right: 5px;
              font-style: normal;
              font-size: 16px;
            }
          }

          span:nth-child(2) {
            font-size: 18px;
          }

          span:nth-child(4) {
            margin-bottom: 0;
          }
        }

        .couponItemBot {
          height: 40px;
          line-height: 40px;
          background: #f3f3f3;
          color: #333333;
          position: relative;
          text-align: center;
          cursor: pointer;

          .currentSelect {
            color: $mainColor;
            position: absolute;
            right: -1px;
            bottom: 0;
            font-size: 40px;
          }
        }
      }

      .active {
        border: 1px solid $mainColor;
      }
    }

    .couponList {
      margin-top: 10px;

      .payTit {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;
      }

      .dialog-footer {
        display: flex;
        justify-content: flex-end;
      }

      .confimPaymentDays1 {
        width: 111px;
        height: 44px;
        line-height: 44px;
        background: #f5f5f5;
        border-radius: 2px;
        border: 1px solid #e5e5e4;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        margin-right: 22px;
        cursor: pointer;
      }

      .confimPaymentDays2 {
        width: 140px;
        height: 44px;
        line-height: 44px;
        background: #f77b0b;
        border-radius: 2px;
        border: 1px solid #f77b0b;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        margin-right: 0;
        cursor: pointer;
      }

      >>>.el-dialog__header {
        text-align: left;
      }

      >>>.el-dialog__body {
        background-color: #fff;
        padding: 30px 48px 26px 48px;
      }

      >>>.el-dialog__footer {
        padding: 0 48px 30px 48px;
      }

      .confimPaymentDaysContent {
        >.p1 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #606266;
          line-height: 36px;
        }

        >p:last-child {
          margin-top: 17px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;

          >span {
            margin-left: 18px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #f77b0b;
            line-height: 20px;
          }
        }
      }

      .confirmApplyForMoney {
        padding: 20px 0;

        >div {
          text-align: center;

          >img {
            width: 74px;
            height: 74px;
          }
        }

        >div:last-child {
          margin-top: 15px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 28px;
        }
      }
    }
  }

  .payBox {
    // .payTit {
    //   font-size: 20px;
    //   color: #333333;
    //   font-weight: bold;
    // }
  }

  .placeOrderBtn {
    margin-top: 50px;
    width: 100%;
    background: #f7f7f7;
    padding: 30px;
    box-sizing: border-box;
    text-align: right;

    span {
      display: block;
      margin-bottom: 20px;
      font-size: 14px;
      color: #333333;
    }

    span:nth-child(3) {
      font-size: 18px;

      b {
        color: $mainColor;
      }
    }
  }

  // .payList {
  //   display: flex;
  //   margin: 20px 0 0 50px;
  //   span {
  //     color: #666666;
  //     font-size: 16px;
  //     font-weight: 400;
  //     display: flex;
  //     align-items: center;
  //     cursor: pointer;
  //     position: relative;
  //     i {
  //       font-size: 26px;
  //       margin-right: 5px;
  //     }
  //     b {
  //       color: $mainColor;
  //       position: absolute;
  //       right: -1px;
  //       bottom: -1px;
  //       display: none;
  //     }
  //   }
  //   .payActive {
  //     border: 1px solid $mainColor;
  //     b {
  //       display: block;
  //     }
  //   }
  //   span {
  //     border: 1px solid #E5E5E5;
  //     padding: 5px 10px;
  //     margin-right: 15px;
  //   }
  //   span:nth-child(1) {
  //     i:nth-child(1) {
  //       color: #40ba49;
  //       cursor: pointer;
  //     }
  //   }
  //   span:nth-child(2) {
  //     i {
  //       color:  #40ba49;
  //     }
  //   }
  // }
  .payList {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &>div {
      width: 467px;
      height: 120px;
      border-radius: 8px;
      border: 1px solid #d4d4d4;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      cursor: pointer;
      padding: 0 20px;
      position: relative;
      overflow: hidden;
      margin: 0 5px 10px;

      &>img {
        max-width: 66px;
        max-height: 64px;
        margin-right: 20px;
      }

      &>div {
        display: flex;
        flex-direction: column;
        justify-content: center;

        &>p:nth-child(1) {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 10px;
        }

        &>p:nth-child(2) {
          font-size: 14px;
          color: #606266;

          span {
            font-size: 14px;
            color: #ff4747;
            font-weight: bold;
          }
        }
      }

      .hint {
        height: 26px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #606266;
        margin-left: 11px;
      }

      .gray {
        color: #606266 !important;
      }

      .open {
        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #f77b0b !important;
        }
      }
    }

    .p1 {
      font-size: 14px;
      font-family: MicrosoftYaHei !important;
      color: #f77b0b !important;
      line-height: 19px !important;
    }

    .payActive {
      border-color: #f77b0b;
    }

    .payActive {
      &>span {
        position: absolute;
        width: 83px;
        height: 70px;
        background: #f77b0b;
        color: #ffffff;
        font-size: 30px;
        border-radius: 50%;
        right: -32px;
        top: -37px;
        display: flex;
        align-items: flex-end;
        padding: 0 0 4px 13px;
      }
    }
  }

  .payment {
    width: 80%;
    margin: 0 auto;

    .paymentBox {
      margin-top: 50px;
      display: flex;
      justify-content: center;

      .successBox,
      .errorBox {
        width: 240px;
        text-align: center;
      }

      .successBox {
        border-right: 1px solid #dddddd;

        >>>.el-button {
          border: 1px solid $mainColor;
        }
      }

      span {
        display: block;
        margin-bottom: 20px;
      }
    }

    .paymentInfo {
      text-align: center;
      margin-top: 60px;

      p {
        font-size: 16px;
        color: #999999;
        line-height: 30px;

        b {
          color: #ff7800;
          cursor: pointer;
          font-weight: normal;
        }
      }
    }
  }

  .weChatBox {
    // display: flex;
    // justify-content: center;
    text-align: center;

    img {
      width: 100%;
    }

    .qCode {
      padding: 10px 20px;
      width: 100%;
      text-align: center;

      img {
        width: 60%;
      }
    }

    .weChatInfo {
      width: 50%;
    }
  }

  .weChat {
    >>>.el-dialog__body {
      background: #ffffff;
    }
  }

  .errorDialog {
    text-align: center;

    .errorTit {
      span {
        font-size: 50px;
        color: red;
      }

      p {
        margin: 30px 0;
      }
    }

    span {
      display: block;
    }
  }

  .remarksBox {
    display: flex;
    background: #f7f7f7;
    padding: 25px;
    border-radius: 8px;
    margin-bottom: 30px;

    .remarksInfo {
      width: 100%;

      >>>.el-textarea__inner {
        width: 100%;
        height: 84px;
      }
    }

    .selectBox {
      margin-left: 70px;

      label {
        color: #666666;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .shopTotal {
      color: $mainColor;
      flex: 1;
      text-align: right;
    }
  }
}

.el-dialog__title {
  padding: 0 20px !important;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/views/placeOrder_serv/index.vue